import { UserForm } from "../../App/Types/UsersType";
import { PaginationResponse, PagedStatsResponse } from "../../Shared/Pagination/PaginationResponse";
import { deleteApi, getApi, getApiById, getApiListById, postApi, postApiByPathParam, postApiWithoutBody, putApi } from "../../Shared/Services/RestService";
import { adminCreditTopUpResponse, adminMenuResponse, adminSettingsResponse, AdminSettingsCatalogEntry, architectureExperienceResponse, businessImpactTypeResponse, cityResponse, CoreExpertiseResponse, decisionSpeedResponse, DomainExpertiseResponse, domainResponse, GenerateInviteResponseDTO, hiringAuthorityResponse, JumpStartServiceResponseDTO, ownerShipLevelRequest, ownerShipLevelResponse, productScaleResponse, reputationSignalsResponse,  roleLevelResponse, scoreConfigResponse, scoreValueMappingResponse, searchConfigResponse, startupRiskPreferenceResponse, SystemConfigCategoryResponse, SystemConfigEntryResponse, targetRoleResponse, TeamSizeLevelsResponse, TechnologyStackResponse, workFlexibilityResponse, workStyleResponse } from "../Types/AdminType";
import { FeedbackResponseDto, FeedbackStats } from "../Types/FeedbackType";
import { RevokeInviteResponse } from "../Types/GrowthType";
import { ValidationPolicy } from "../../Shared/Utils/validationPolicy";





export const getAllTargetRole = () => {
  return getApi<targetRoleResponse[]>("/admin/target-role");
};

export const createTargetRole = (payload: any) => {
  return postApi<targetRoleResponse>("/admin/target-role", payload);
};

export const updateTargetRole = (payload: any, id: string) => {
  return putApi<targetRoleResponse>("/admin/target-role",id, payload);
};

export const deleteTargetRole = (id: string) => {
  return deleteApi<targetRoleResponse>("/admin/target-role",id);
};




export const getAllOwnerShipLevel = () => {
  return getApi<ownerShipLevelResponse[]>("/admin/ownership-level");
};

export const createOwnerShipLevel = (payload: any) => {
  return postApi<ownerShipLevelResponse>("/admin/ownership-level", payload);
};

export const updateOwnerShipLevel = (payload: any, id: string) => {
  return putApi<ownerShipLevelResponse>("/admin/ownership-level",id, payload);
};

export const deleteOwnerShipLevel = (id: string) => {
  return deleteApi<ownerShipLevelResponse>("/admin/ownership-level",id);
};






export const getAllTeamSizeLevels = () => {
  return getApi<TeamSizeLevelsResponse[]>("/admin/ownership-level");
};

export const createTeamSizeLevels = (payload: any) => {
  return postApi<TeamSizeLevelsResponse>("/admin/ownership-level", payload);
};

export const updateTeamSizeLevels = (payload: any, id: string) => {
  return putApi<TeamSizeLevelsResponse>("/admin/ownership-level",id, payload);
};

export const deleteTeamSizeLevels = (id: string) => {
  return deleteApi<TeamSizeLevelsResponse>("/admin/ownership-level",id);
};



export const getAllHiringAuthority = () => {
  return getApi<hiringAuthorityResponse[]>("/admin/hiring-authority");
};

export const createHiringAuthority = (payload: any) => {
  return postApi<hiringAuthorityResponse>("/admin/hiring-authority", payload);
};

export const updateHiringAuthority = (payload: any, id: string) => {
  return putApi<hiringAuthorityResponse>("/admin/hiring-authority",id, payload);
};
export const deleteHiringAuthority = (id: string) => {
  return deleteApi<hiringAuthorityResponse>("/admin/hiring-authority",id);
};






export const getAllArchitectureExperience = () => {
  return getApi<architectureExperienceResponse[]>("/admin/architecture-experience");
};

export const createArchitectureExperience = (payload: any) => {
  return postApi<architectureExperienceResponse>("/admin/architecture-experience", payload);
};

export const updateArchitectureExperience = (payload: any, id: string) => {
  return putApi<architectureExperienceResponse>("/admin/architecture-experience",id, payload);
};

export const deleteArchitectureExperience = (id: string) => {
  return deleteApi<architectureExperienceResponse>("/admin/architecture-experience",id);
};




export const getAllProductScale = () => {
  return getApi<productScaleResponse[]>("/admin/product-scale");
};

export const createProductScale = (payload: any) => {
  return postApi<productScaleResponse>("/admin/product-scale", payload);
};

export const updateProductScale = (payload: any, id: string) => {
  return putApi<productScaleResponse>("/admin/product-scale",id, payload);
};

export const deleteProductScale = (id: string) => {
  return deleteApi<productScaleResponse>("/admin/product-scale",id);
};


export const getAllBusinessImpactType= () => {
  return getApi<businessImpactTypeResponse[]>("/admin/business-impact-type");
};

export const createBusinessImpactType = (payload: any) => {
  return postApi<businessImpactTypeResponse>("/admin/business-impact-type", payload);
};

export const updateBusinessImpactType = (payload: any, id: string) => {
  return putApi<businessImpactTypeResponse>("/admin/business-impact-type",id, payload);
};
export const deleteBusinessImpactType = (id: string) => {
  return deleteApi<businessImpactTypeResponse>("/admin/business-impact-type",id);
};





export const getAllWorkStyle= () => {
  return getApi<workStyleResponse[]>("/admin/workstyle");
};

export const createWorkStyle = (payload: any) => {
  return postApi<workStyleResponse>("/admin/workstyle", payload);
};

export const updateWorkStyle = (payload: any, id: string) => {
  return putApi<workStyleResponse>("/admin/workstyle",id, payload);
};

export const deleteWorkStyle = (id: string) => {
  return deleteApi<workStyleResponse>("/admin/workstyle",id);
};



export const getAllWorkFlexibility= () => {
  return getApi<workFlexibilityResponse[]>("/admin/work-flexibility");
};

export const createWorkFlexibility = (payload: any) => {
  return postApi<workFlexibilityResponse>("/admin/work-flexibility", payload);
};

export const updateWorkFlexibility = (payload: any, id: string) => {
  return putApi<workFlexibilityResponse>("/admin/work-flexibility",id, payload);
};

export const deleteWorkFlexibility = (id: string) => {
  return deleteApi<workFlexibilityResponse>("/admin/work-flexibility",id);
};


export const getAllTechnologyStack= () => {
  return getApi<TechnologyStackResponse[]>("/admin/technology-stack");
};

export const createTechnologyStack = (payload: any) => {
  return postApi<TechnologyStackResponse>("/admin/technology-stack", payload);
};

export const updateTechnologyStack = (payload: any, id: string) => {
  return putApi<TechnologyStackResponse>("/admin/technology-stack",id, payload);
};

export const deleteTechnologyStack = (id: string) => {
  return deleteApi<TechnologyStackResponse>("/admin/technology-stack",id);
};


export const getAllCoreExpertise= () => {
  return getApi<CoreExpertiseResponse[]>("/admin/core-expertises");
};

export const createCoreExpertise = (payload: any) => {
  return postApi<CoreExpertiseResponse>("/admin/core-expertises", payload);
};

export const updateCoreExpertise = (payload: any, id: string) => {
  return putApi<CoreExpertiseResponse>("/admin/core-expertises",id, payload);
};

export const deleteCoreExpertise = (id: string) => {
  return deleteApi<CoreExpertiseResponse>("/admin/core-expertises",id);
};


export const getAllDomainExpertise= () => {
  return getApi<DomainExpertiseResponse[]>("/admin/domain-expertises");
};

export const createDomainExpertise = (payload: any) => {
  return postApi<DomainExpertiseResponse>("/admin/domain-expertises", payload);
};

export const updateDomainExpertise = (payload: any, id: string) => {
  return putApi<DomainExpertiseResponse>("/admin/domain-expertises",id, payload);
};

export const deleteDomainExpertise = (id: string) => {
  return deleteApi<DomainExpertiseResponse>("/admin/domain-expertises",id);
};



  export const getAllDecisionSpeed= () => {
    return getApi<decisionSpeedResponse[]>("/admin/decision-speed");
  };

  export const createDecisionSpeed = (payload: any) => {
    return postApi<decisionSpeedResponse>("/admin/decision-speed", payload);
  };

  export const updateDecisionSpeed = (payload: any, id: string) => {
    return putApi<decisionSpeedResponse>("/admin/decision-speed",id, payload);
  };

  export const deleteDecisionSpeed = (id: string) => {
  return deleteApi<decisionSpeedResponse>("/admin/decision-speed",id);
};



export const getAllStartupRiskPreference= () => {
  return getApi<startupRiskPreferenceResponse[]>("/admin/startup-risk-preference");
};

export const createStartupRiskPreference = (payload: any) => {
  return postApi<startupRiskPreferenceResponse>("/admin/startup-risk-preference", payload);
};

export const updateStartupRiskPreference = (payload: any, id: string) => {
  return putApi<startupRiskPreferenceResponse>("/admin/startup-risk-preference",id, payload);
};

  export const deleteStartupRiskPreference = (id: string) => {
  return deleteApi<startupRiskPreferenceResponse>("/admin/startup-risk-preference",id);
};



export const getAllReputationSignals= () => {
  return getApi<reputationSignalsResponse[]>("/admin/reputation-signals");
};

export const createReputationSignals = (payload: any) => {
  return postApi<reputationSignalsResponse>("/admin/reputation-signals", payload);
};

export const updateReputationSignals = (payload: any, id: string) => {
  return putApi<reputationSignalsResponse>("/admin/reputation-signals",id, payload);
};
  export const deleteReputationSignals = (id: string) => {
  return deleteApi<reputationSignalsResponse>("/admin/reputation-signals",id);
};




export const getAllRoleLevel= () => {
  return getApi<roleLevelResponse[]>("/admin/role-level");
};

export const createRoleLevel = (payload: any) => {
  return postApi<roleLevelResponse>("/admin/role-level", payload);
};

export const updateRoleLevel= (payload: any, id: string) => {
  return putApi<roleLevelResponse>("/admin/role-level",id, payload);
};
 export const deleteRoleLevel = (id: string) => {
  return deleteApi<roleLevelResponse>("/admin/role-level",id);
};




export const getAllAdminMenus = () => {
  return getApi<adminMenuResponse[]>("/admin/menu");
};

export const createAdminMenu = (payload: any) => {
  return postApi<adminMenuResponse>("/admin/menu", payload);
};

export const updateAdminMenu = (payload: any, id: string) => {
  return putApi<adminMenuResponse>("/admin/menu",id, payload);
};



export const getAllScoreConfig= () => {
  return getApi<scoreConfigResponse[]>("/admin/score-config");
};

export const createScoreConfig = (payload: any) => {
  return postApi<scoreConfigResponse>("/admin/score-config", payload);
};

export const updateScoreConfig= (payload: any, id: string) => {
  return putApi<scoreConfigResponse>("/admin/score-config",id, payload);
};
 export const deleteScoreConfig = (id: string) => {
  return deleteApi<scoreConfigResponse>("/admin/score-config",id);
};


export const getAllScoreValueMappingConfig= () => {
  return getApi<scoreValueMappingResponse[]>("/admin/score-value");
};

export const getAllScoreValueMappingConfigByFieldName= (fieldName: string) => {
  return getApiById<scoreValueMappingResponse[]>("/admin/score-value/field", fieldName);
};

export const createScoreValueMappingConfig = (payload: any) => {
  return postApi<scoreValueMappingResponse>("/admin/score-value", payload);
};

export const updateScoreValueMappingConfig= (payload: any, id: string) => {
  return putApi<scoreValueMappingResponse>("/admin/score-value",id, payload);
};
 export const deleteScoreValueMappingConfig = (id: string) => {
  return deleteApi<scoreValueMappingResponse>("/admin/score-value",id);
};



export const getAllSearchConfig= () => {
  return getApi<searchConfigResponse[]>("/admin/search-filters");
};

export const getAllSearchConfigByTier= (fieldName: string) => {
  return getApiById<searchConfigResponse[]>("/admin/search-filters/tier", fieldName);
};

export const createSearchConfig = (payload: any) => {
  return postApi<searchConfigResponse>("/admin/search-filters", payload);
};

export const updateSearchConfig= (payload: any, id: string) => {
  return putApi<searchConfigResponse>("/admin/search-filters",id, payload);
};
 export const deleteSearchConfig = (id: string) => {
  return deleteApi<searchConfigResponse>("/admin/search-filters",id);
};


export const getAllAdminSettings = () => {
  return getApi<adminSettingsResponse[]>("/admin/settings");
};

export const createAdminSetting = (payload: any) => {
  return postApi<adminSettingsResponse>("/admin/settings", payload);
};

export const updateAdminSetting = (payload: any, id: string) => {
  return putApi<adminSettingsResponse>("/admin/settings", id, payload);
};

export const deleteAdminSetting = (id: string) => {
  return deleteApi<adminSettingsResponse>("/admin/settings", id);
};

export const getAdminSettingsCatalog = () => {
  return getApi<AdminSettingsCatalogEntry[]>("/admin/settings/catalog");
};

export const revealAdminSetting = (id: string) => {
  return getApi<adminSettingsResponse>(`/admin/settings/${id}/reveal`);
};


export const getAllUsersByStatus= (status: string) => {
  return getApi<UserForm[]>(`/admin/users/${status}`);
};

export const getAllUsersByStatusAndRole= (status: string, role: string) => {
  return getApi<UserForm[]>(`/admin/users/${role}/${status}`);
};


export const getAllUsersByRole= (role: string) => {
  return getApi<UserForm[]>(`/admin/users/role/${role}`);
};

export const sendLaunchEmailToPlatformUsers = (role: string) => {
  const suffix = role ? `?role=${encodeURIComponent(role)}` : '';
  return postApiByPathParam<UserForm[]>(`/admin/users/email${suffix}`);
};


export const approveUserByAdmin = (payload: any) => {
  return postApi<UserForm>("/admin/user/approved", payload);
};

export const rejectUserByAdmin = (payload: any) => {
  return postApi<UserForm>("/admin/user/rejected", payload);
};


export const topUpCredits = (payload: any) => {
  return postApi<adminCreditTopUpResponse>("/admin/credits/topup", payload);
};


export const deleteUserByAdmin = (id: string) => {
  return deleteApi<string>("/users", id);
};


export const generateInviteLink = (payload: any) => {
  return postApi<GenerateInviteResponseDTO>("/users/invitation/generate", payload);
};

export const validateInviteCode = (inviteCode: string) => {
    return getApi<UserForm>(`/users/invitation/validate/${inviteCode}`);
};

/**
 * Calls back an invite link the caller generated but nobody has used yet. Only works inside the
 * invite's 24 hour window and only for the caller's own links; the server rejects it otherwise
 * and returns the error message to surface.
 */
export const revokeInviteLink = (inviteCode: string) => {
    return postApiWithoutBody<RevokeInviteResponse>(
        `/users/invitation/${encodeURIComponent(inviteCode)}/revoke`
    );
};


export const runJumpStartService = (serviceName: string) => {
  return postApiByPathParam<JumpStartServiceResponseDTO>(`/admin/jump-start/${serviceName}`);
};





export const getAllFeedback = (page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApi<PaginationResponse<FeedbackResponseDto>>("/feedbacks/all", params);
};

export const getAllFeedbackByUser = (userId: string, page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApiListById<PaginationResponse<FeedbackResponseDto>>("/feedbacks/all", userId, params);
};

export interface FeedbackFilters {
  search?: string;
  category?: string;
  priority?: string;
  status?: string;
  /** WEB-DIRECT | CANDIDATE | RECRUITER */
  source?: string;
  fromDate?: string;
  toDate?: string;
}

/**
 * Filtered + paginated feedback listing for one user, plus aggregate stats.
 * `userId` is the current recruiter's user id.
 */
export const getUserFeedbackFiltered = (
  userId: string,
  filters: FeedbackFilters = {},
  page: number = 0,
  size?: number
) => {
  const params: any = {
    page,
  };

  if (filters.search) params.search = filters.search;
  if (filters.category && filters.category !== "ALL") params.category = filters.category;
  if (filters.priority && filters.priority !== "ALL") params.priority = filters.priority;
  if (filters.status && filters.status !== "ALL") params.status = filters.status;
  if (filters.fromDate) params.fromDate = filters.fromDate;
  if (filters.toDate) params.toDate = filters.toDate;
  if (size !== undefined) params.size = size;

  return getApi<PagedStatsResponse<FeedbackResponseDto, FeedbackStats>>(
    `/feedbacks/all/${userId}/filtered`,
    params
  );
};

/**
 * Filtered + paginated feedback listing across all users (admin area), plus aggregate stats.
 */
export const getAdminFeedbackFiltered = (
  filters: FeedbackFilters = {},
  page: number = 0,
  size?: number
) => {
  const params: any = {
    page,
  };

  if (filters.search) params.search = filters.search;
  if (filters.category && filters.category !== "ALL") params.category = filters.category;
  if (filters.priority && filters.priority !== "ALL") params.priority = filters.priority;
  if (filters.status && filters.status !== "ALL") params.status = filters.status;
  if (filters.source && filters.source !== "ALL") params.source = filters.source;
  if (filters.fromDate) params.fromDate = filters.fromDate;
  if (filters.toDate) params.toDate = filters.toDate;
  if (size !== undefined) params.size = size;

  return getApi<PagedStatsResponse<FeedbackResponseDto, FeedbackStats>>(
    `/feedbacks/all/filtered`,
    params
  );
};

export const getAllFeedbackByAdmin= (fieldName: string) => {
  return getApiById<FeedbackResponseDto[]>("/admin/search-filters/tier", fieldName);
};

export const createFeedback = (payload: any) => {
  return postApi<FeedbackResponseDto>("/feedbacks", payload);
};

export const updateFeedbackByUser= (payload: any, id: string) => {
  return putApi<FeedbackResponseDto>("/feedbacks/user",id, payload);
};

export const updateFeedbackByAdmin= (payload: any, id: string) => {
  return putApi<FeedbackResponseDto>("/feedbacks/admin",id, payload);
};
 export const deleteFeedback = (id: string) => {
  return deleteApi<FeedbackResponseDto>("/feedbacks",id);
};




export const getAllCities = () => {
  return getApi<cityResponse[]>("/location");
};

export const getAllDomains = () => {
  return getApi<domainResponse[]>("/domain");
};

export const getSystemConfiguration = () => {
  return getApi<ValidationPolicy>("/system-configuration");
};

export const updateSystemConfiguration = (key: string, value: boolean) => {
  return putApi<ValidationPolicy>("/system-configuration", key, { value });
};

export const getSystemConfigCategories = () => {
  return getApi<SystemConfigCategoryResponse[]>("/admin/system-config/categories");
};

export const getSystemConfigCategory = (category: string) => {
  return getApi<SystemConfigCategoryResponse>(`/admin/system-config/categories/${category}`);
};

export const updateSystemConfig = (category: string, key: string, value: string) => {
  return putApi<SystemConfigEntryResponse>("/admin/system-config/categories", `${category}/${key}`, { value });
};

export const revealSystemConfig = (category: string, key: string) => {
  return getApi<SystemConfigEntryResponse>(`/admin/system-config/categories/${category}/${key}/reveal`);
};